// let currencyCode = $('#CurrencySelector-desktop-header').attr('value');
function formatPrice(price) {
    var formattedPrice = (price / 100).toFixed(2); // Convert cents to dollars and fix to 2 decimal places
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD' // Change 'USD' to your desired currency code
      }).format(formattedPrice);
    }
//  // Function to generate HTML for a cart item
//   function generateCartItemHTML(item) {
//     // Create HTML for the item using the provided item object
//     // Extract properties from the item object
//     var propertiesHTML = '';
//     for (var prop in item.properties) {
//       if (item.properties.hasOwnProperty(prop) && item.properties[prop]) {
//         propertiesHTML += `<p class="${prop}"><strong>${prop}:</strong> ${item.properties[prop]}</p>`;
//       }
//     }
//     var groupId = '';
//     for (const prop in item.properties) {
//       if (item.properties.hasOwnProperty(prop) && prop === 'timestamp') {
//         groupId = item.properties[prop];
//         break;
//       }
//     }
//     // Get the image URL
//       var imageUrl = item.image;
      
//       // Split the URL into parts using the "." as a delimiter
//       var parts = imageUrl.split(".");
      
//       // Get the file extension
//       var extension = parts.pop();
      
//       // Append "_400x" before the extension
//       var resizedImageUrl = parts.join(".") + "_200x." + extension;
//         // Generate savings HTML if there's a discount
//       const savingsHTML = item.total_discount && item.discounts && item.discounts.length > 0
//         ? `<div class="cart__items__savings">
//             <span class="item__total__savings">
//               <span class="cart__icon--tags"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tags" viewBox="0 0 14 14"><g stroke="#000" fill="none" stroke-width=".875" stroke-linecap="round" stroke-linejoin="round"><path d="M2.625.79H7l6.125 6.124m-7.8-4.374H1.75a.875.875 0 00-.875.874V6.99c0 .232.092.455.256.619l5.344 5.345a.875.875 0 001.438-.312l.837-2.227 2.228-.836a.875.875 0 00.311-1.438L5.944 2.795a.874.874 0 00-.619-.256zM3.5 4.946"></path><path d="M3.5 4.946a.219.219 0 10.001 0H3.5"></path></g></svg></span>
//               You're saving ${formatPrice(item.total_discount)} with ${item.discounts[0].title}
//             </span>
//           </div>`
//         : '';

//     var html = `
//     <div class="cdk_cart_item" key-id="${item.key}" data-groupid="${groupId}">
//       <div class="cdk_cart_inner">
//         <div class="image_box">
//           <a href="${ item.url }">
//           <img src="${resizedImageUrl}" />
//           </a>
//         </div>
//         <div class="content_box">
//           <p class="cart_title"><a href="${ item.url }">${item.title}</a></p>
          
//           <div class="cart_item_price">
//             <p class="cart_price">
//               ${formatPrice(item.final_price)}
//             </p>
//           </div>
//           <div class="cart-properties">${propertiesHTML}</div>
//           <div class="cart_item_control">
//             <div class="quantity-control">
//               <span class="decrease-quantity-btn">-</span>
//               <input type="text" class="item-quantity" value="${item.quantity}" />
//               <span class="increase-quantity-btn">+</span>
//             </div>
//             <span class="cdk_remove">
//             <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bin" viewBox="0 0 11 14"><path d="M10 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V2h9zM9 3H2v9a1 1 0 00.883.993L3 13h5a1 1 0 00.993-.883L9 12V3z"></path><path d="M10.5 2a.5.5 0 110 1H.5a.5.5 0 010-1h10zm-3-2a.5.5 0 010 1h-4a.5.5 0 010-1h4z"></path></svg>
//             </span>
//           </div>
//         </div>
//       </div>
//       ${savingsHTML}
//     </div>`;
//     return html;
//   }

  function updateMiniCart(){
  $.ajax({
    type: "GET", 
    url: '/',
    dataType: 'html',

    success: function(data) {
      getCartItemCount();
      var miniCartHead = $(data).find('#CartDrawer').html(); 
      // console.log('miniCartHead::'+miniCartHead);
      $('#CartDrawer').html(miniCartHead);  
    }
  })
}

function getCartItemCount() {
  const excludedVariants = ['41108858437797', '42252064129189', '42252064096421']; // Add the variants to exclude

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cartData) {
      // Calculate the total number of items in the cart, excluding specific variants
      let itemCount = 0;

      cartData.items.forEach(function(item) {
        if (!excludedVariants.includes(item.variant_id.toString())) {
          itemCount += item.quantity;
        }
      });

      // Update the UI with the item count
      if (itemCount >= 100) {
        $('.header__cart__status[data-header-cart-count]').attr('data-header-cart-count', '99+');
        $('.header__cart__status .custom_count').text(itemCount);
      } else if (itemCount == 0){
        $('.header__cart__status[data-header-cart-count]').attr('data-header-cart-count', itemCount);
        $('.header__cart__status .custom_count').text(itemCount);
        $('.cdesk-cart-drawer').addClass('is-empty');
      } else {
        $('.header__cart__status[data-header-cart-count]').attr('data-header-cart-count', itemCount);
        $('.header__cart__status .custom_count').text(itemCount);
      }

      console.log('Cart item count (excluding specified variants):', itemCount);
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      console.error('Error fetching cart data:', textStatus, errorThrown);
    }
  });
}

// function updateCartItemCount(keyId) {
//   var keysInUI = $('.cdk_cart_item').map(function() {
//     return $(this).attr('key-id');
//   }).get();
   
//   $.ajax({
//     type: 'GET',
//     url: '/cart.js',
//     dataType: 'json',
//     success: function(cartData) {
//       var itemCount = cartData.item_count;
//       var cartSubTotal = cartData.original_total_price; // Assuming total price is in the cart data
//       var cartDisocunt = cartData.total_discount; // Assuming total price is in the cart data
//       var cartTotal = cartData.total_price; // Assuming total price is in the cart data
//       var cartLength = cartData.items.length;
      
//       // Get the number of items in the cart
//       var numberOfItems = $('.cdk_cart_item').length; 

//       // Initialize a variable to store the total sum
//       var totalSum = 0;
//       $('.cdk_cart_item input.item-quantity').each(function() {
//           var quantity = parseFloat($(this).val());
//           totalSum += quantity;
//       });
//       // console.log("Number of items in the cart:", numberOfItems);
//       // console.log('cartLength::'+cartLength);
//       // console.log('itemCount::'+itemCount);
//       // console.log('totalSum::'+totalSum);

//       // if (cartLength != numberOfItems) {
     
//       //    $('.cdk_cart_items_main').empty(); // Clear existing cart items

//       //     for (var i = 0; i < cartData.items.length; i++) {
//       //       var newItemHTML = generateCartItemHTML(cartData.items[i]);
//       //       $('.cdk_cart_items_main').append(newItemHTML);
//       //     }
//       // } else if (itemCount != totalSum) {
     
//       //    $('.cdk_cart_items_main').empty(); // Clear existing cart items

//       //     for (var i = 0; i < cartData.items.length; i++) {
//       //       var newItemHTML = generateCartItemHTML(cartData.items[i]);
//       //       $('.cdk_cart_items_main').append(newItemHTML);
//       //     }
//       // } 

//       $('.cdk_cart_items_main').empty();
//         cartData.items.forEach(item => {
//           var newItemHTML = generateCartItemHTML(item);
//           $('.cdk_cart_items_main').append(newItemHTML);
//       });


//       if (itemCount >= 100) {
//         $('.header__cart__status[data-header-cart-count]').attr('data-header-cart-count', '99+');
//       } else {
//         $('.header__cart__status[data-header-cart-count]').attr('data-header-cart-count', itemCount);
//       }

//       if(cartSubTotal != cartTotal){
//         $('.cdk_cart_subtotal').text(formatPrice(cartData.original_total_price));
//         $('.cart_main-price .cdk_cart_subtotal').show();
//       }else{
//         $('.cdk_cart_subtotal').text(formatPrice(cartData.original_total_price));
//         $('.cart_main-price .cdk_cart_subtotal').hide();
//       }
      
//       // if(cartDisocunt != '0'){
//       //   $('.cdk_cart_disocunt').text('-'+ formatPrice(cartData.total_discount) );
//       //   // $('.cdk_cart_footer .cdk_cart_footer_item.cart_discount').show();
//       // }else{
//       //   $('.cdk_cart_disocunt').text('-'+ formatPrice(cartData.total_discount) );
//       //   // $('.cdk_cart_footer .cdk_cart_footer_item.cart_discount').hide();
//       // }
      
//       if(cartTotal != '0'){
//         $('.cdk_cart_total').text(formatPrice(cartData.total_price));
//         $('.cdk_cart_payment-info strong').text(formatPrice(cartData.total_price / 4));
//         $('.cdk_cart_footer .cdk_cart_footer_item.cart_total').show();
//         $('.drawer__footer').show();
//         $('.drawer__inner-empty').hide();
//       }else{
//         $('.cdk_cart_total').text(formatPrice(cartData.total_price));
//         $('.cdk_cart_footer .cdk_cart_footer_item.cart_total').hide();
//         $('.drawer__footer').hide();
//         $('.drawer__inner-empty').show();
//         $('.cdesk-cart-drawer').addClass('is-empty');
//       }
      
//       $('.cdk_cart_item').removeClass('loading');
      
//       $('body,html').addClass('overflow__hidden');
//     },
//     error: function(XMLHttpRequest, textStatus, errorThrown) {
//       console.error('Error fetching cart data:', textStatus, errorThrown);
//     }
//   });
// }
// Function to update cart item on Shopify
function updateCartItem(keyId, newQuantity) {
  var data = {
    updates: {}
  };
  data.updates[keyId] = newQuantity;

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      // Handle success if needed
      // updateMiniCart();
      updateMiniCart();
    },
    error: function(xhr, status, error) {
      // Handle error if needed
    }
  });
}
function ajaxAddToCartProduct(currentThis, dynamicData) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { items: dynamicData },
    dataType: "json",
    success: function (data) { 
      updateMiniCart();
      $('.cdesk-cart-drawer').removeClass('is-empty');
      $('.cdesk-cart-drawer').addClass('active'); 
      $('body').addClass('overflow__hidden');
      setTimeout(function() {
        $('.custom_add_to_cart').removeClass('loading');
      }, 1500);
      // $('.cdk-product-block-btn').find('.btn_text').removeClass('product-loading');
      // $('.cdk-product-block-btn').find('.loading-overlay__spinner').addClass('hidden');
      
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if (jqXHR.status == 400) {
        alert(jqXHR.responseJSON.message);
        $('.custom_add_to_cart').removeClass('loading');
      }
      if (jqXHR.status == 422) {
        alert(jqXHR.responseJSON.description);
        $('.custom_add_to_cart').removeClass('loading');
      }
    },
  });
}

// Update cart items by group
function updateGroupedCartItem(groupId, operation) {
  const groupItems = $(`.cdk_cart_item[data-groupid="${groupId}"]`);
  const updates = {};
  
  groupItems.each(function() {
    const keyId = $(this).attr('key-id');
    const currentQty = parseInt($(this).find('.item-quantity').val());
    const newQty = operation === 'remove' ? 0 : 
                   operation === 'increase' ? currentQty + 1 : 
                   operation === 'decrease' ? Math.max(0, currentQty - 1) : currentQty;
    
    updates[keyId] = newQty;
    $(this).find('.item-quantity').val(newQty);
  });

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: { updates: updates },
    dataType: 'json',
    success: function(cart) { 
      updateMiniCart();
      if (operation === 'remove' || Object.values(updates)[0] === 0) {
        groupItems.slideUp(400, function() {
          $(this).remove();
        });
      }
    },
    error: function(xhr, status, error) {
      console.error('Error updating cart:', error);
      groupItems.removeClass('loading');
    }
  });
}

$(document).ready(function(){
  
  $(document).on('click','.drawer__close, .cart-drawer__overlay', function(event){
    event.stopPropagation();
    event.preventDefault();
    $('.cdesk-cart-drawer').removeClass('active');
    $('body,html').removeClass('overflow__hidden');
    $('html').removeAttr('data-scroll-locked');
    // $('.cart-drawer__collection').slick('unslick');
    // $('.cdesk-cart-drawer').removeClass('active');
  })
  
  $(document).mouseup(function(ee){
    ee.preventDefault();
    ee.stopPropagation();
    
      var container = $(".cdesk-cart-drawer .drawer__inner");
   
      // If the target of the click isn't the container
      if(!container.is(ee.target) && container.has(ee.target).length === 0){
        $('.cdesk-cart-drawer').removeClass('active');
        $('body,html').removeClass('overflow__hidden');
      }
  });


//   // Increase quantity button
//   $(document).on('click', '.increase-quantity-btn', function() {
//     var $cartItem = $(this).closest('.cdk_cart_item');
//     var keyId = $cartItem.attr('key-id');
//     var $quantity = $cartItem.find('.item-quantity');
//     var newQuantity = parseInt($quantity.val()) + 1;
//     $cartItem.addClass('loading');
//     updateCartItem(keyId, newQuantity);
//     $quantity.val(newQuantity);
//   });

//   // Decrease quantity button
//   $(document).on('click', '.decrease-quantity-btn', function() {
//     var $cartItem = $(this).closest('.cdk_cart_item');
//     var keyId = $cartItem.attr('key-id');
//     var $quantity = $cartItem.find('.item-quantity');
//     var newQuantity = parseInt($quantity.val()) - 1;
//     $cartItem.addClass('loading');
    
//     if (newQuantity >= 0) {
//       updateCartItem(keyId, newQuantity);
//       $quantity.val(newQuantity);
//     }
//     if (newQuantity == 0) {
//       $cartItem.slideDown().remove();
//     }
//   });

//  // Remove quantity button
//   $(document).on('click', '.cdk_remove', function() {
//     var $cartItem = $(this).closest('.cdk_cart_item');
//     var keyId = $cartItem.attr('key-id'); 
//     var newQuantity = 0;
//     $cartItem.addClass('loading');
    
//     updateCartItem(keyId, newQuantity);
//     // $cartItem.slideDown().remove();
//     setTimeout(function() {
//       $cartItem.slideDown().remove();
//     }, 1000);
//   });


  // Quantity increase handler
  $(document).on('click', '.increase-quantity-btn', function() {
    const $cartItem = $(this).closest('.cdk_cart_item');
    const groupId = $cartItem.attr('data-groupid');
    $(`.cdk_cart_item[data-groupid="${groupId}"]`).addClass('loading');
    updateGroupedCartItem(groupId, 'increase');
  });

  // Quantity decrease handler
  $(document).on('click', '.decrease-quantity-btn', function() {
    const $cartItem = $(this).closest('.cdk_cart_item');
    const groupId = $cartItem.attr('data-groupid');
    const currentQty = parseInt($cartItem.find('.item-quantity').val());
    
    if (currentQty > 0) {
      $(`.cdk_cart_item[data-groupid="${groupId}"]`).addClass('loading');
      updateGroupedCartItem(groupId, 'decrease');
    }
  });

  // Remove item handler
  $(document).on('click', '.cdk_remove', function() {
    const $cartItem = $(this).closest('.cdk_cart_item');
    const groupId = $cartItem.attr('data-groupid');
    $(`.cdk_cart_item[data-groupid="${groupId}"]`).addClass('loading');
    updateGroupedCartItem(groupId, 'remove');
  });

  
  $(document).on('click','.custom_add_to_cart',function(){ 
    var currentThis = $(this);
    var updateItems = [];
    var variantId = $(this).parents('.custom_add_cart_form').find('.current_variant_input').attr("value");
    var quantity = 1;
    var extraVariantId = $(this).parents('.custom_add_cart_form').find('.overlay_btn').attr("data-var");
    const nowTimestamp = new Date().getTime();
    $(this).parents('.custom_add_cart_form').find('.timestamp').val(nowTimestamp);
    const isChecked = $('#ptw-gift-needed1').prop('checked');

    let ExtraVariantId;
    if (extraVariantId) {
      ExtraVariantId = isChecked ? $('#ptw-gift-needed1').attr('data-var') : extraVariantId;
    }
    
    if (ExtraVariantId) {
        updateItems.push({ 
            "id": ExtraVariantId, 
            "quantity": quantity,
            "properties": { "_timestamp": nowTimestamp }
        });
    }
    updateItems.push({ 
        "id": variantId, 
        "quantity": quantity,
        "properties": { "_timestamp": nowTimestamp }
    });
    
    ajaxAddToCartProduct(currentThis,updateItems);
    currentThis.addClass('loading');
    $('html').attr('data-scroll-locked','');
    $('body,html').addClass('overflow__hidden');
      
  });

  $(document).on('click', '.custom_cart_opener', function() {
    $('.cdesk-cart-drawer').addClass('active');
    $('body,html').addClass('overflow__hidden');
  });

});
  
// CART DRAWER

// // Gift card management function
// function manageGiftCard(cartTotal) {
//   const giftCardVariantId = "42697896132773";
//   let targetQuantity = 0;
//   let firstFreegiftval = $('.cdesk-cart-drawer').attr('free_gift_one');
//   let secondFreegiftval = $('.cdesk-cart-drawer').attr('free_gift_second');

//   // Determine target quantity based on cart total, max 2
//   if (cartTotal >= secondFreegiftval) {
//     targetQuantity = 2;
//   } else if (cartTotal >= firstFreegiftval) {
//     targetQuantity = 1;
//   }

//   // Get current gift card in cart
//   return $.ajax({
//     type: 'GET',
//     url: '/cart.js',
//     dataType: 'json'
//   }).then(function(cart) {
//     const giftCardItem = cart.items.find(item => item.variant_id.toString() === giftCardVariantId);
//     const currentQuantity = giftCardItem ? giftCardItem.quantity : 0;

//     let timestamp = null;
//     $('.cdk_cart_items_main .cdk_cart_item').each(function() {
//       if (!$(this).is('[style*="display: none"]')) {
//         const groupId = $(this).attr('data-groupid');
//         if (groupId) {
//           timestamp = groupId;
//           return false; // Break the loop after finding the first visible item's timestamp
//         }
//       }
//     });

//     if (!timestamp) {
//       timestamp = new Date().getTime();
//     }

//     if (currentQuantity === targetQuantity) {
//       return Promise.resolve(); // Do nothing if quantities match
//     }

//     if (giftCardItem) {
//       // Update existing gift card quantity
//       return $.ajax({
//         type: 'POST',
//         url: '/cart/change.js',
//         data: {
//           id: giftCardItem.key,
//           quantity: targetQuantity,
//           // properties: {
//           //   'timestamp': timestamp,
//           //   '_auto_gift': 'true'
//           // }
//         },
//         dataType: 'json'
//       }).then(function() {
//         // After updating, check and refresh the cart
//         checkAndUpdateCart();  // Trigger cart update to ensure UI reflects changes
//       });
//     } else if (targetQuantity > 0) {
//       // Add new gift card only if it doesn't exist and is needed
//       return $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {
//           items: [{
//             id: giftCardVariantId,
//             quantity: targetQuantity,
//             // properties: {
//             //   'timestamp': timestamp,
//             //   '_auto_gift': 'true'
//             // }
//           }]
//         },
//         dataType: 'json'
//       }).then(function() {
//         // After adding, check and refresh the cart
//         checkAndUpdateCart();  // Trigger cart update to ensure UI reflects changes
//       });
//     }

//     return Promise.resolve(); // Return resolved promise if no action needed
//   });
// }

// function checkAndUpdateCart() {
//   $.ajax({
//     type: 'GET',
//     url: '/cart.js',
//     dataType: 'json',
//     success: function(cartData) {
//       const cartTotal = cartData.total_price;
//       const giftCardVariantId = "42697896132773";
      
//       // Check if the gift card is in the cart and if the total has changed
//       const giftCardItem = cartData.items.find(item => item.variant_id.toString() === giftCardVariantId);

//       if (giftCardItem) {
//         updateCartItemCount();
//       }
//     }
//   });
// }

//   function updateMiniCart(){
//   $.ajax({
//     type: "GET", 
//     url: '/',
//     dataType: 'html',

//     success: function(data) {
//       var miniCartHead = $(data).find('#CartDrawer').find('.cdk_cart_footer_item.cart_total').html(); 
//       var miniCartship = $(data).find('#CartDrawer').find('.free-shipping-main').html(); 
//       var MiniCartShip = $(data).find('#CartDrawer').find('.free-shipping').html();
//       var miniCartItems = $(data).find('#CartDrawer').find('.cdk_cart_main').html(); 
//       // console.log('miniCartHead::'+miniCartHead);
//       $('#CartDrawer .cdk_cart_footer_item.cart_total').html(miniCartHead);
//       $('#CartDrawer .free-shipping-main').html(miniCartship);
//       $('#CartDrawer .free-shipping').html(MiniCartShip);
//       $('#CartDrawer .cdk_cart_main').html(miniCartItems);
//     }
//   })
// }

// // Price formatting utility
// function formatPrice(price) {
//   const formattedPrice = (price / 100).toFixed(2);
//   return new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: 'USD'
//   }).format(formattedPrice);
// }

// // Generate HTML for cart items
// function generateCartItemHTML(item) {
//   // Process item properties
//   let propertiesHTML = '';
//   for (const prop in item.properties) {
//     if (item.properties.hasOwnProperty(prop) && item.properties[prop]) {
//       propertiesHTML += `<p class="${prop}"><strong>${prop}:</strong> ${item.properties[prop]}</p>`;
//     }
//   }

//   // Get groupId from timestamp property
//   let groupId = '';
//   for (const prop in item.properties) {
//     if (item.properties.hasOwnProperty(prop) && prop === 'timestamp') {
//       groupId = item.properties[prop];
//       break;
//     }
//   }

//   // Process image URL for thumbnail
//   const imageUrl = item.image;
//   const parts = imageUrl.split(".");
//   const extension = parts.pop();
//   const resizedImageUrl = parts.join(".") + "_200x." + extension;

//   // Generate sale price HTML if there's a discount
//   const salePriceHtml = item.original_price > item.final_price 
//     ? `<del class="sale">${formatPrice(item.original_price)}</del>` 
//     : '';

//   // Generate vendor HTML if available
//   const variantHtml = item.variant_title 
//     ? `<p class="item__vendor">${item.variant_title}</p>` 
//     : '';

//   // Generate savings HTML if there's a discount
//   const savingsHTML = item.total_discount && item.discounts && item.discounts.length > 0
//     ? `<div class="cart__items__savings">
//          <span class="item__total__savings">
//            <span class="cart__icon--tags"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tags" viewBox="0 0 14 14"><g stroke="#000" fill="none" stroke-width=".875" stroke-linecap="round" stroke-linejoin="round"><path d="M2.625.79H7l6.125 6.124m-7.8-4.374H1.75a.875.875 0 00-.875.874V6.99c0 .232.092.455.256.619l5.344 5.345a.875.875 0 001.438-.312l.837-2.227 2.228-.836a.875.875 0 00.311-1.438L5.944 2.795a.874.874 0 00-.619-.256zM3.5 4.946"></path><path d="M3.5 4.946a.219.219 0 10.001 0H3.5"></path></g></svg></span>
//            You're saving ${formatPrice(item.total_discount)} with ${item.discounts[0].title}
//          </span>
//        </div>`
//     : '';

//   // Check if the item ID matches the specified IDs to remove links
//   const restrictedIds = ['42252064096421', '42252064129189', '42506552770725', '42278579798181'];
//   const shouldRemoveLinks = restrictedIds.includes(item.id.toString());

//   // Check if the item ID matches the specified IDs to display none item
//   const restrictIds = ['42252064096421', '42252064129189', '42506552770725'];
//   const hideItem = restrictIds.includes(item.id.toString());

//   // Generate image and title elements based on whether links should be removed
//   const imageElement = shouldRemoveLinks
//     ? `<img src="${resizedImageUrl}" alt="${item.product_title}" />`
//     : `<a href="${item.url}"><img src="${resizedImageUrl}" alt="${item.product_title}" /></a>`;

//   const titleElement = shouldRemoveLinks
//     ? `<p class="cart_title">${item.product_title}</p>`
//     : `<p class="cart_title"><a href="${item.url}">${item.product_title}</a></p>`;

//   const displayStyle = hideItem ? ' style="display: none;"' : '';

//   return `
//     <div class="cdk_cart_item" key-id="${item.key}" data-groupid="${groupId}" ${displayStyle}>
//       <div class="cdk_cart_inner">
//         <div class="image_box">
//           ${imageElement}
//         </div>
//         <div class="content_box">
//           ${titleElement}
//           ${variantHtml}
//           <div class="cart_item_price">
//             <p class="cart_price">${formatPrice(item.final_price)}</p>
//             ${salePriceHtml}
//           </div>
//           <div class="cart-properties">${propertiesHTML}</div>
//           <div class="cart_item_control">
//             <div class="quantity-control">
//               <span class="decrease-quantity-btn">-</span>
//               <input type="text" class="item-quantity" value="${item.quantity}" />
//               <span class="increase-quantity-btn">+</span>
//             </div>
//             <span class="cdk_remove">
//               <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bin" viewBox="0 0 11 14">
//                 <path d="M10 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V2h9zM9 3H2v9a1 1 0 00.883.993L3 13h5a1 1 0 00.993-.883L9 12V3z"></path>
//                 <path d="M10.5 2a.5.5 0 110 1H.5a.5.5 0 010-1h10zm-3-2a.5.5 0 010 1h-4a.5.5 0 010-1h4z"></path>
//               </svg>
//             </span>
//           </div>
//         </div>
//       </div>
//       ${savingsHTML}
//     </div>
//   `;
// }

// // Update cart items by group
// function updateGroupedCartItem(groupId, operation) {
//   const groupItems = $(`.cdk_cart_item[data-groupid="${groupId}"]`);
//   const updates = {};
  
//   groupItems.each(function() {
//     const keyId = $(this).attr('key-id');
//     const currentQty = parseInt($(this).find('.item-quantity').val());
//     const newQty = operation === 'remove' ? 0 : 
//                    operation === 'increase' ? currentQty + 1 : 
//                    operation === 'decrease' ? Math.max(0, currentQty - 1) : currentQty;
    
//     updates[keyId] = newQty;
//     $(this).find('.item-quantity').val(newQty);
//   });

//   $.ajax({
//     type: 'POST',
//     url: '/cart/update.js',
//     data: { updates: updates },
//     dataType: 'json',
//     success: function(cart) {
//       updateCartItemCount();
//       if (operation === 'remove' || Object.values(updates)[0] === 0) {
//         groupItems.slideUp(400, function() {
//           $(this).remove();
//         });
//       }
//     },
//     error: function(xhr, status, error) {
//       console.error('Error updating cart:', error);
//       groupItems.removeClass('loading');
//     }
//   });
// }

// // Update cart UI
// function updateCartItemCount() {
//   $.ajax({
//     type: 'GET',
//     url: '/cart.js',
//     dataType: 'json',
//     success: function(cartData) {
//       const itemCount = cartData.item_count;
//       const cartSubTotal = cartData.original_total_price;
//       const cartDiscount = cartData.total_discount;
//       const cartTotal = cartData.total_price;

      
//       const excludeItemIds = ["42252064096421", "42252064129189", "42506552770725"];
      
//       // Start with the initial cart item count
//       let adjustedItemCount = cartData.item_count;
  
//       // Loop through items in the cartData
//       cartData.items.forEach(item => {
//         // If item ID is in the exclusion list, subtract its quantity from the count
//         if (excludeItemIds.includes(item.id.toString())) {
//           adjustedItemCount -= item.quantity;
//         }
//       });
      
//       // Manage gift card based on cart total
//       manageGiftCard(cartTotal).then(() => {
//       updateMiniCart();
//       // Update cart badge
//       // $('.header__cart__status [data-header-cart-count]').attr('data-header-cart-count', adjustedItemCount >= 100 ? '99+' : adjustedItemCount);
//       $('.custom_count').text(adjustedItemCount >= 100 ? '99+' : adjustedItemCount);

//       // Update price displays
//       $('.cdk_cart_subtotal').text(formatPrice(cartSubTotal));
//       $('.cdk_cart_disocunt').text('-' + formatPrice(cartDiscount));
//       $('.cdk_cart_total').text(formatPrice(cartTotal));
//       $('.cdk_cart_payment-info strong, [data-subtotal-pay]').text(formatPrice(cartTotal / 4));

//       // Show/hide UI elements based on cart state
//       if (cartTotal === 0) {
//         $('.drawer__footer').hide();
//         $('.drawer__inner-empty').show();
//         $('.cdesk-cart-drawer').addClass('is-empty');
//       } else {
//         $('.drawer__footer').show();
//         $('.drawer__inner-empty').hide();
//         $('.cdesk-cart-drawer').removeClass('is-empty');
//       }

//       // Handle subtotal display
//       // if (cartSubTotal !== cartTotal) {
//       //   $('.cart_main-price .cdk_cart_subtotal').show();
//       // } else {
//       //   $('.cart_main-price .cdk_cart_subtotal').hide();
//       // }

//       // Refresh cart items if needed
//       // refreshCartItems(cartData);

//       // Remove loading state
//       $('.cdk_cart_item').removeClass('loading');
//       }).catch(error => {
//         console.error('Error managing gift card:', error);
//         $('.cdk_cart_item').removeClass('loading');
//       });
//     },
//     error: function(xhr, status, error) {
//       console.error('Error fetching cart data:', error);
//     }
//   });
// }

// // Refresh cart items
// function refreshCartItems(cartData) {
//   const currentItems = $('.cdk_cart_item').length;
//   const cartLength = cartData.items.length;
  
//   let totalQuantity = 0;
//   $('.cdk_cart_item input.item-quantity').each(function() {
//     totalQuantity += parseInt($(this).val());
//   });
  
//   if (cartLength !== currentItems || cartData.item_count !== totalQuantity) {
//     $('.cdk_cart_items_main').empty();
//     cartData.items.forEach(item => {
//       const newItemHTML = generateCartItemHTML(item);
//       $('.cdk_cart_items_main').append(newItemHTML);
//     });
//   }
// }

// // Add items to cart
// function ajaxAddToCartProduct(currentThis, dynamicData) {
//   $.ajax({
//     url: "/cart/add.js",
//     type: "POST",
//     data: { items: dynamicData },
//     dataType: "json",
//     success: function(data) {
//       updateCartItemCount();
//       checkAndUpdateCart();
//       $('body').addClass('overflow__hidden');
//       setTimeout(function() {
//         $('.custom_add_to_cart').removeClass('loading');
//         $('.custom_add_to_cart').addClass('has-success');
//         $('.cdesk-cart-drawer')
//           .removeClass('is-empty')
//           .addClass('active');
//         $('.upsell__modal').removeClass('is-open');
//         $('body').removeAttr('style');
//       }, 1700);
//       setTimeout(function() {
//         $('.custom_add_to_cart').removeClass('has-success');
//       }, 3000);
//     },
//     error: function(jqXHR, textStatus, errorThrown) {
//       $('.custom_add_to_cart').removeClass('loading');
//       if (jqXHR.status === 400) {
//         alert(jqXHR.responseJSON.message);
//       }
//       if (jqXHR.status === 422) {
//         alert(jqXHR.responseJSON.description);
//       }
//     }
//   });
// }

// // Document ready handlers
// $(document).ready(function() {
//   // Cart drawer close handlers
//   $(document).on('click', '.drawer__close, .cart-drawer__overlay', function(event) {
//     event.preventDefault();
//     event.stopPropagation();
//     $('.cdesk-cart-drawer').removeClass('active');
//     $('body,html').removeClass('overflow__hidden');
//     $('html').removeAttr('data-scroll-locked');
//   });

//   // Click outside cart drawer handler
//   $(document).mouseup(function(event) {
//     event.preventDefault();
//     event.stopPropagation();
    
//     const container = $(".cdesk-cart-drawer .drawer__inner");
//     if (!container.is(event.target) && container.has(event.target).length === 0) {
//       $('.cdesk-cart-drawer').removeClass('active');
//       $('body,html').removeClass('overflow__hidden');
//       $('html').removeAttr('data-scroll-locked');
//     }
//   });

//   // Quantity increase handler
//   $(document).on('click', '.increase-quantity-btn', function() {
//     const $cartItem = $(this).closest('.cdk_cart_item');
//     const groupId = $cartItem.attr('data-groupid');
//     $(`.cdk_cart_item[data-groupid="${groupId}"]`).addClass('loading');
//     updateGroupedCartItem(groupId, 'increase');
//   });

//   // Quantity decrease handler
//   $(document).on('click', '.decrease-quantity-btn', function() {
//     const $cartItem = $(this).closest('.cdk_cart_item');
//     const groupId = $cartItem.attr('data-groupid');
//     const currentQty = parseInt($cartItem.find('.item-quantity').val());
    
//     if (currentQty > 0) {
//       $(`.cdk_cart_item[data-groupid="${groupId}"]`).addClass('loading');
//       updateGroupedCartItem(groupId, 'decrease');
//     }
//   });

//   // Remove item handler
//   $(document).on('click', '.cdk_remove', function() {
//     const $cartItem = $(this).closest('.cdk_cart_item');
//     const groupId = $cartItem.attr('data-groupid');
//     $(`.cdk_cart_item[data-groupid="${groupId}"]`).addClass('loading');
//     updateGroupedCartItem(groupId, 'remove');
//   });

//   // Add to cart button handler
//   $(document).on('click', '.custom_add_to_cart', function() {
//     const currentThis = $(this);
//     const updateItems = [];
//     const $form = currentThis.parents('.custom_add_cart_form');
//     const variantId = $form.find('.current_variant_input').attr("value");
//     const quantity = 1;
//     const extraVariantId = $form.find('.overlay_btn').attr("data-var");
//     const nowTimestamp = new Date().getTime();
    
//     $form.find('.timestamp').val(nowTimestamp);
//     const isChecked = currentThis.parents('.product__block__buttons').find('#ptw-gift-needed1').prop('checked');
//   console.log('extraVariantId::'+extraVariantId);
//       console.log('isChecked::'+isChecked);
//     let ExtraVariantId;
//     // if (extraVariantId) {}
//       ExtraVariantId = isChecked ? currentThis.parents('.product__block__buttons').find('#ptw-gift-needed1').attr('data-var') : extraVariantId;
    
//      console.log('ExtraVariantId::'+ExtraVariantId);
//     if (ExtraVariantId) {
//       updateItems.push({ 
//         "id": ExtraVariantId, 
//         "quantity": quantity,
//         "properties": { "timestamp": nowTimestamp }
//       });
//     }
    
//     updateItems.push({ 
//       "id": variantId, 
//       "quantity": quantity,
//       "properties": { "timestamp": nowTimestamp }
//     });
    
//     ajaxAddToCartProduct(currentThis, updateItems);
//     currentThis.addClass('loading');
//     $('html').attr('data-scroll-locked', '');
//     $('body,html').addClass('overflow__hidden');
//   });
//   $(document).on('click', '.custom_cart_opener', function() {
//     $('.cdesk-cart-drawer').addClass('active');
//     $('body,html').addClass('overflow__hidden');
//   });
//   $(document).on('click','#CartDrawer .drawer__bottom__notes .accordion__title',function(){
//     $(this).toggleClass('active');
//     $(this).next().slideToggle();
//     $(this).next().toggleClass('active');
//   })
// });